import getRecords from "./getRecords"
import getDetailRecord from "./getDetailRecord"

export { getRecords, getDetailRecord }

const account = { getRecords, getDetailRecord }

export default account
